import React, { useEffect, useState } from 'react';
import Logo from '../../../../assets/images/neophyte_logo.png';
import '../videoPage/video.css';
import { useSelector } from 'react-redux';

const EvidenceVideo = ({ vdoSource, videoList, setSource }) => {
  const [currentIndex, setCurrentIndex] = useState(videoList.findIndex((video) => `${video.src}` === vdoSource));
  const selectedSource = useSelector((state) => state.customization.videoSource);
  const [showVideo, setShowVideo] = useState(selectedSource);

  useEffect(() => {
    const newIndex = videoList.findIndex((video) => `${video.src}` === vdoSource);
    setCurrentIndex(newIndex !== -1 ? newIndex : 0);
  }, [vdoSource, videoList]);

  useEffect(() => {
    setShowVideo(selectedSource);
  }, [selectedSource]);

  const handleVideoEnd = () => {
    const nextIndex = (currentIndex + 1) % videoList.length;
    setCurrentIndex(nextIndex);
    setSource(`${videoList[nextIndex].src}`);
  };
  console.log('sdsd', selectedSource);

  return (
    <div className="video-component">
      {showVideo ? (
        <video
          width="100%"
          height="60vh"
          style={{ borderRadius: '10px', maxHeight: '60vh', minHeight: '60vh', maxWidth: '100%', minWidth: '100%' }}
          controls
          autoPlay
          muted
          onEnded={handleVideoEnd}
        >
          <source src={showVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <div className="flex flex-col justify-center" style={{ height: '60vh' }}>
          <img src={Logo} alt="Logo" />
        </div>
      )}
    </div>
  );
};

export default EvidenceVideo;
